export default __webpack_public_path__ + "static/media/widget4-img.e1737b4e.jpg";